import { graphql } from "@graphql-generated/gql";

export const assetsTrackingByIdGraphql = graphql(`
    query AssetsTrackingById($id: ID!) {
        assetBusinessById(id: $id) {
            id
            reference
            asset {
                id
                lastPositionMeasure {
                    value
                    recordedTime
                    mode
                    modeNetwork
                    id
                }
                lastLockMeasure {
                    value
                }
            }
            assetType {
                id
                features
            }
        }
    }
`);

export const PositionMeasures = graphql(`
    query PositionMeasures($querySetting: QuerySettingInput!) {
        positionMeasures(querySetting: $querySetting) {
            totalCount
            items {
                id
                value
                recordedTime
                time
                mode
                modeNetwork
            }
        }
    }
`);

export const ResolvedTenantConfigGraphql = graphql(`
    query ResolvedTenantConfig($configKey: String!) {
        resolvedTenantConfig(configKey: $configKey) {
            value
        }
    }
`);

/*
export const AssetEventsGraphql = graphql(`
    query AssetEvents($querySetting: QuerySettingInput!) {
        rawEvents(querySetting: $querySetting) {
            totalCount
            items {
                id
                time
                data
                beEventType {
                    name
                    id
                }
            }
        }
    }
`);
*/

export const AssetEventsGraphql = graphql(`
    query AssetEvents($querySetting: QuerySettingInput!) {
        rawEventsWithNoDuplicatedValues(querySetting: $querySetting) {
            totalCount
            items {
                id
                time
                data
                beEventType {
                    name
                    id
                }
            }
        }
    }
`);

